<template>
  <div lass="input-group">
    <b-input-group v-if="label"
      class="mb-3"
      :prepend="label"
    >
      <b-form-input
        :id="idComputed"
        type="number"
        :state="nameState"
        v-model="number"
        :autofocus="autofocus"
        @focusout="validateOnfocusOutMethod"
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="disabled"
        @keyup.enter.exact="$emit('click')"
      />
      <b-input-group-append v-if="buttonName">
        <b-button
          size="md"
          text="Button"
          :variant="variant"
          :disabled="v.$error || isProcessing"
          @click="$emit('click', $event.target.value)"
        >
        <span v-if="isProcessing">
          <b-spinner small></b-spinner>
          {{buttonName}}...
        </span>
        <span v-else>{{buttonName}}</span>
      </b-button>
      </b-input-group-append>
      <b-form-invalid-feedback v-if="!v.required">{{ $t('field_required')}}</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="v.isValid === false"> {{ $t('field_invalid')}} </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="v.numeric === false"> {{ $t('number_required')}} </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="v.minLength === false"> {{ $tc('number_min_length', minLengthCharactersRequired )}} </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="v.maxLength === false"> {{ $tc('number_max_length', maxLengthCharactersAllowed )}} </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="v.exactLength === false"> {{ $tc('number_exact_length', exactLengthRequired )}} </b-form-invalid-feedback>
    </b-input-group>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  props: {
    buttonName: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'primary'
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nameState () {
      return this.v.$error ? false : null
    },
    number: {
      get () {
        return this.value
      },
      set (value) {
        if (Object.entries(this.v).length) {
          this.v.$touch()
        }
        this.$emit('input', value)
      }
    }
  }
}
</script>
